import React, { forwardRef, useContext, useId, useRef, useState, useSyncExternalStore } from "react"
import { Button as ReactstrapButton } from "reactstrap"
import { createRequestActivity, withRequestActivity } from "../services/requestActivity"
import { SubmissionContext } from "./ApiForm"

const createButton = (Component) => forwardRef(function ApiButton(
  { children, onClick, disabled, loading = false, replaceContentOnLoading = false, ...props }, ref
) {
  const activity = useRef(null)
  if (!activity.current) activity.current = createRequestActivity()
  const pending = useSyncExternalStore(activity.current.subscribe, activity.current.isPending, () => false)
  const id = useId()
  const submitter = useContext(SubmissionContext)
  const locked = useRef(false)
  const [running, setRunning] = useState(false)
  const busy = pending || running || loading || submitter === id

  const handleClick = async (event) => {
    if (disabled || busy || locked.current || activity.current.isPending()) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
    locked.current = true
    try {
      const result = withRequestActivity(activity.current, () => onClick?.(event))
      if (result && typeof result.then === "function") {
        setRunning(true)
        await result
      }
    } finally {
      locked.current = false
      setRunning(false)
    }
  }

  return React.createElement(
    Component,
    { ...props, ref, disabled: disabled || busy, "data-api-button-id": id, "aria-busy": busy || undefined, onClick: handleClick },
    busy ? <span className={`spinner-border spinner-border-sm${replaceContentOnLoading ? "" : " me-1"}`} aria-hidden="true" /> : null,
    busy && replaceContentOnLoading ? null : children
  )
})

export const NativeApiButton = createButton("button")
export default createButton(ReactstrapButton)
